/* eslint-disable no-new-object */
import React, { Component } from "react";
import Landing from "./LandingContainer";
import Form, { formTypes } from "../../Forms/Containers/FormCreator";
// import Button from "@material-ui/core/Button";
import { LANDING_MENU_BAR } from "./../../constants/strings/StringsDashboard";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as modalActs from "./../../Actions/Modal";
import * as sessionActs from "./../../Actions/Session";

import { sendService } from '../../Services/service'

import Warning from "@material-ui/icons/Warning";

import "./../changePasswordContainer.css";

class ChangePasswordContainer extends Component {
  state = {
    form: {}
  };
  handlerChange = (variable, value) => {
    this.setState({
      form: {
        ...this.state.form,
        [variable]: value
      }
    });
  };


  modal = (text) => {
    return (
      <>
        <div>
          <div className="modal-icon">
            <div className="center">
              <Warning />
            </div>
            ADVERTENCIA
          </div>
          <div className="modal-message">{text}</div>
          <div className="container-content">
            <Form
              onChange={this.handlerChange}
              objectCreator={[
                {
                  type: formTypes.div,
                  classContainer: "line line-40"
                },
                {
                  type: formTypes.submit,
                  classContainer: "button-primary line line-20 text-center",
                  label: "Aceprtar",
                  placeholder: "-"
                },
                {
                  type: formTypes.div,
                  classContainer: "line line-40"
                }
              ]}
              onSubmit={this.closeModal}
            />
          </div>
        </div>
      </>
    );
  };

  closeModal = (status) => {
    this.props.modalActions.closeModal()
  }

  handlerSubmit = async () => {
    console.log(this.state.form)
    let resp = await sendService('/api/v1/users/changePassword', 'PUT', this.state.form)
    if (resp.status === 200 || resp.status === 400) {
      this.props.modalActions.openModal(this.modal(resp.response.msg))
    } else {
      this.props.sessionAction.closeSession();
      this.onChangeRoute("/")
    }
  };

  render() {
    const defaultProperties = {
      classLabel: "input-text",
      classContainer: "input-text-change-password",
      required: true,
      viewPassword: true,
      type: formTypes.password,
    }
    return (
      <Landing history={this.props.history} hasFooter={true}>
        <>
          <div>
            <h1 className="page-title">{LANDING_MENU_BAR.CHANGE_PASSWORD}</h1>
          </div>
          <div className="background-body">
            <div className='change-password-form'>
              <Form
                className="input-div-change-password input-text-change-password"
                onChange={this.handlerChange}
                objectCreator={[
                  {
                    ...defaultProperties,
                    label: "Contraseña actual",
                    placeholder: "Ingrese su contraseña",
                    variable: "oldPassword",
                  },
                  {
                    ...defaultProperties,
                    label: "Contraseña nueva",
                    placeholder: "Dígite su nueva contraseña",
                    // value: '',
                    variable: "newPassword",
                  },
                  {
                    ...defaultProperties,
                    label: "Confirmar contraseña",
                    placeholder: "Confirme su nueva contraseña",
                    variable: "confirmNewPassword",
                    equalTo: "newPassword",
                  },
                  {
                    type: formTypes.submit,
                    classContainer: "button-primary line line-50 text-center",
                    label: "Enviar",
                    placeholder: "-"
                  },
                  {
                    type: formTypes.click,
                    classContainer: "button-secondary line line-50 text-center",
                    label: "Cancelar",
                    placeholder: "-"
                  }
                ]}
                onSubmit={this.handlerSubmit}
                values={this.state.form}
              />
            </div>

            {/* <div className="button-div-change-password">
              <Button
                variant="contained"
                onClick={this.handleClose}
                color="primary"
                className="boton-capital boton-cancelar-password"
              >
                Cancelar
              </Button>
              <Button
                variant="contained"
                onClick={this.onSave}
                color="secondary"
                className="boton-capital boton-guardar-password"
              >
                Guardar
              </Button>
            </div> */}
          </div>
        </>
      </Landing>
    );
  }
}

// export default ChangePasswordContainer;

function mapStateToProps(state, props) {
  return {
    session: state.session
    // open: state.modal.open,
    // children: state.modal.children
  };
}


function mapDispatchToProps(dispatch) {
  return {
    modalActions: bindActionCreators(modalActs, dispatch),
    sessionActions: bindActionCreators(sessionActs, dispatch)
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(ChangePasswordContainer);
